module.exports = __webpack_public_path__ + "static/media/game_icon_capybara.b86cf59d.png";